export default __webpack_public_path__ + "static/media/Token of the Divinity Serpent.75cca5e9.jpg";